import React, { useEffect, useLayoutEffect, useState } from 'react';
import NewEmailMessage from './_NewEmailMessage';


type Props = {
    messageId?: string;
    uId?: number;
    message: any;
    isAdmin?: boolean;
    activeMail: string;
    sendMail: Function;
    onMoveMessageClick: Function;
    onSetMessageClick: Function;
    onStarClick: Function;
    onDeleteMessage?: Function;
    openPopup?: Function;
    mainAccount: any;
    folderName?: string;
    folderType?: string;
    fromTreatment?: boolean;
    ClosePopup?: Function;
    showPopUpMessage?: Function;
};
const EmailContentShow = (props: Props) => {
    const [showNewEmail, setShowNewEmail] = useState<boolean>(false);
    const [newEmailType, setNewEmailType] = useState<string>('reply');
    const [newEmailBody, setNewEmailBody] = useState<string>('');
    const [newMessageRecipients, setNewMessageRecipients] = useState<string>(props.message.from)
    const [newMessageCcRecipients, setNewMessageCcRecipients] = useState<string>('')
    const [newMessageSubject, setNewMessageSubject] = useState<string>('')
    const [isStar, setIsStar] = useState<boolean>(props.message.star)
    const [showBtnOptions, setShowBtnOptions ] = useState<boolean>(false);
    const [attachments, setAttachments] = useState<any[]>([]);
    const [senderName, setSenderName] = useState<string>(props.message.from == props.mainAccount.emailAddress ? props.mainAccount.name : props.message.fromName);

    
    useLayoutEffect(() => {
        console.log('useLayoutEffect props.message', props)

    }, [])
    useEffect(()=>{
        console.log("props.message", props.message);
        
        if (props.message.from == props.mainAccount.email) {
            setSenderName(props.mainAccount.name)
        }
        console.log('EmailContentShow',props)
    }, [])

    const sendMail = (formData: any) => {
        return props.sendMail(formData, props.messageId);
    }

    const onStarClick = async() => {
        props.onStarClick(props.messageId);
        setIsStar(!isStar);
    }
    
    const onMoveMessage = () => {
        setShowBtnOptions(false);
        props.onMoveMessageClick(props.messageId)
    }
    const onSetMessage = () => {
        setShowBtnOptions(false);
        props.onSetMessageClick(props.messageId)
    }
    const onDeleteMessage = () => {
        setShowBtnOptions(false);
        if(props.isAdmin && props.onDeleteMessage) {
            props.onDeleteMessage(props.messageId)
        }
    }

    const onOptionsBtnClick = () => {
        if (showBtnOptions) {
            setShowBtnOptions(false);
        } else {
            setShowBtnOptions(true);
        }
    }

    const onReplyClick =async () => {
        await setShowNewEmail(false);
        await setNewEmailType('reply');
        await setNewMessageCcRecipients('');
        await setAttachments([]); 
        setNewMessageSubject(`RE: ${props.message.subject}`);
        let recipientsToStr = '';
        const message = props.message
        console.log('onReplyClick', message);
        if (message && message.envelope) {
            await setShowNewEmail(false);
            getNewMessageBody();
            message.envelope.from.forEach((fa: any) => {
                if (recipientsToStr != '') {
                    recipientsToStr += ',';
                }
                recipientsToStr += fa.address;
            });
            await setNewMessageRecipients(recipientsToStr);
            await setShowNewEmail(true);
        }
    }

    const getNewMessageBody = () => {
        let htmlBody = '<p></p><hr />' + props.message.htmlBody;
        setNewEmailBody(htmlBody);
    }

    const onReplyToAllClick = async () => {
        await setNewEmailType('reply');
        await setShowNewEmail(false);
        await setNewMessageCcRecipients('');
        await setNewMessageRecipients('');
        await setAttachments([]); 
        setNewMessageSubject(`RE: ${props.message.subject}`);
        let recipientsToStr = '';
        let recipientsCcStr = '';
        const message = props.message
        console.log('onReplyToAllClick', message);
        if (message && message.envelope) {
            message.envelope.from.forEach((fa: any) => {
                if (recipientsToStr != '') {
                    recipientsToStr += ',';
                }
                recipientsToStr += fa.address;
            });
            message.envelope.to.forEach((fa: any) => {
                if (recipientsToStr != '') {
                    recipientsToStr += ',';
                }
                recipientsToStr += fa.address;
            });
            message.envelope.cc.forEach((fa: any) => {
                if (recipientsCcStr != '') {
                    recipientsCcStr += ',';
                }
                recipientsCcStr += fa.address;
            });
            await setNewMessageRecipients(recipientsToStr)
            await setNewMessageCcRecipients(recipientsCcStr);
            await setShowNewEmail(true);
        }
    }

    const onForwardClick = async () => {
        await setNewEmailType('forward');
        await setNewMessageCcRecipients('');
        await setNewMessageRecipients('');
        await setNewMessageSubject(`FW: ${props.message.subject}`);
        await setAttachments(props.message.attachments); 
        await setShowNewEmail(true);
    }

    const onAttachmentClick = (attachment: any) => {
        const byteArrays = [];
        if(!props.fromTreatment){
            const attachmentData = attachment.content.split(';');
            const base64Data = attachmentData[1].replace('base64,', '')
            const byteCharacters = atob(base64Data);
            for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                const slice = byteCharacters.slice(offset, offset + 512);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }
        }

        // for treatment we need to run this function from here and from model email from start of function
        const blob = new Blob(byteArrays, { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = attachment.name; // Set your desired file name here
        document.body.appendChild(link);
        link.click();

        // Clean up
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
    }

    const openPopup = (title: string, text: string) => {
        if (props.openPopup) {
            props.openPopup(
                {
                    title,
                    description: text
                }
            )
        }
    }

    const closePopup = () => {
        if (props.ClosePopup) {
            props.ClosePopup();
        }
    }

    return (
        <>
        <div className="email-content">
            <div className="email-title">
                <div>
                {props.message.subject}
                </div>
                <div className='cell'>
                    <button className="act-btn" onClick={onOptionsBtnClick}>
                        פעולות
                    </button>
                    {showBtnOptions && (<ul className="btn-menu">
                        <li className="pointer"
                            onClick={()=>onSetMessage()}
                        >
                            שייך ל
                        </li>
                        <li className="pointer"
                            onClick={()=>onMoveMessage()}
                        >
                            העבר לתקיה
                        </li>
                        {
                            props.isAdmin ? (<>
                                <li className="pointer"
                                    onClick={()=>onDeleteMessage()}
                                >
                                    מחק
                                </li>
                            </>) : (<></>)
                        }
                    </ul>)}
                </div>
            </div>
            <div className="personal-data-row">
                <div className="person-data">
                    <div className="person-icon">
                        <div className="person-image-holder">
                            <div className="icon person-image"></div>
                        </div>
                    </div>
                    <div className="personal-info">
                        <div className="person-name-email">
                            <span>
                            מֵאֵת: 
                            </span>
                            <span className="person-name">
                                {senderName}
                            </span>
                            <span className="person-email">
                                <a href="mailto:isra.eli@gmail.com" onClick={(e:any)=>{return false;}}>
                                    ({props.message.from})
                                </a>
                            </span>
                        </div>
                        <div className="email-date">
                            <span className='person-name'>נשלח:</span> 
                            {props.message.dateString}
                        </div>
                        <div className="email-recipients">
                            <span className='title'>
                                ל:
                            </span> 
                            {
                               props.message && props.message.envelope && props.message.envelope.to && props.message.envelope.to.length > 0 && props.message.envelope.to.map((r: any, i: number)=>{
                                    return (
                                        <>
                                        <span key={i} title={`${i} `}>
                                            {r.name} ({r.address})
                                        </span>
                                        
                                        {props.message.envelope.to.length > 0 && i < props.message.envelope.to.length-1 ? (<span>, </span>) : ('') }
                                        </>
                                    )
                                })
                            }
                        </div>
                        { props.message && props.message.envelope && props.message.envelope.cc && ( props.message.envelope.cc.length > 0 || props.message.envelope.bcc.length > 0) ? (<>
                            <div className="email-recipients">
                            <span className='title'>
                            עותק:                              
                            </span>
                            {
                                props.message.envelope.cc.map((r: any, i: number)=>{
                                    return (
                                        <>
                                        <span key={i} title={`${i}`}>
                                            {r.name} ({r.address})
                                        </span>
                                        
                                        {props.message.envelope.to.length > 0 && i < props.message.envelope.to.length-1 ? (<span>, </span>) : ('') }
                                        </>
                                    )
                                })
                            }
                            </div>
                            {props.message.envelope.bcc.length > 0 ? (
                            <div className="email-recipients">
                                <span className='title'>
                                עתק:    
                                </span>
                            {
                                props.message.envelope.bcc.map((r: any, i: number)=>{
                                    return (
                                        <>
                                        <span key={i} title={`${i}`}>
                                            {r.name} ({r.address})
                                        </span>
                                        
                                        {props.message.envelope.to.length > 0 && i < props.message.envelope.to.length-1 ? (<span>, </span>) : ('') }
                                        </>
                                    )
                                })
                            }
                            </div>
                            ): ('')}

                        </>) : (<></>)}
                    </div>
                </div>
                <div className="favorite-cell">
                    <div className={`icon star pointer ${isStar ? 'selected' : ''}`} onClick={onStarClick}></div>
                </div>
            </div>
            <div className="message-text" dangerouslySetInnerHTML={{ __html: props.message.htmlBody }}></div>
            {props.message.attachments && props.message.attachments.length > 0 && <div>
                {
                    props.message.attachments.map((attachment: any, i: number)=>{
                        return (
                            <div className='mail-attached-file pointer' onClick={(e: any) => onAttachmentClick(attachment)} key={i}>
                                <div className='icon document-icon'></div>
                                {attachment.name}
                            </div>
                        )
                    })
                }
            </div>}
            {showNewEmail && <NewEmailMessage 
                activeMail={props.activeMail}
                sendMail={(e:any)=>sendMail(e)}
                subject={newMessageSubject}
                cc={newMessageCcRecipients}
                to={newMessageRecipients}
                body={''}
                newEmailType={newEmailType}
                prevHtmlBody={newEmailBody}
                attachments={attachments}
                openPopup={openPopup}
                parentMailId={props.uId?props.uId.toString():''}
                parentMessageId={props.messageId ? props.messageId.toString() : ''}
                folderName={props.folderName}
                folderType={props.folderType}
                showPopUpMessage={props.showPopUpMessage}
                ClosePopup={closePopup}
            />}
        </div>
        <div className="message-footer">
            <span className='pointer bottom-link' onClick={onReplyClick}>השב</span>, 
            <span className='pointer bottom-link' onClick={onReplyToAllClick}>השב לכולם</span>
            או 
            <span className='pointer bottom-link' onClick={onForwardClick}>
                העבר הודעה זו
            </span>
        </div>
        </>
    )
}

export default EmailContentShow;